var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 19.1274 19.6274 24.5 13 24.5C6.37258 24.5 1 19.1274 1 12.5C1 5.87258 6.37258 0.5 13 0.5C19.6274 0.5 25 5.87258 25 12.5Z",
    fill: "#F3F6F6",
    stroke: "#D4DCDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckServiceIcon);
export default __webpack_public_path__ + "static/media/checkServiceIcon.2e49bfc75e4e7fb7eaa4efa4c40e54f2.svg";
export { ForwardRef as ReactComponent };